import { trigger, state, style, transition, animate } from '@angular/animations';
import { AfterViewChecked, AfterViewInit, Component, computed, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ModalRef, MODAL_DATA_VAR, ModalService } from "mis-crystal-design-system/modal";
import { filter, Subscription } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { DataService } from 'src/app/data.service';
import { EmployeeDetailsComponent } from 'src/app/modern-multi-trip-view/components/employee-details/employee-details.component';
import { TABLE_COLUMNS } from 'src/app/modern-multi-trip-view/models/employee-details.model';
import { DateUtils } from 'src/app/utils/days-utils';
@Component({
  selector: 'app-employees-details',
  templateUrl: './employees-details.component.html',
  styleUrls: ['./employees-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class EmployeesDetailsComponent implements OnInit,AfterViewInit,OnChanges , OnDestroy {
  imgSrc: string;
  constructor(public modalRef: ModalRef,private commonService: CommonService,
    @Inject(MODAL_DATA_VAR) data: any, private envService: EnvironmentService , public dataService: DataService,
        private modalSvc:ModalService
  ) { }


    selectedPlannned:boolean=false
    selectedNoShow:boolean=false
    selectedAdHoc:boolean=false
    selectedNotBoarded=false;
    employee_details_list:any=[]
    temp_employee_details_list:any=new MatTableDataSource();
     isFdDistanceEnabled = computed(() => this.dataService.isFdDistanceEnabled());

    employee_detail_column= [
      " ",
      "id",
      "name",
      "phone",
      "gender",
      "pickup",
      "report",
      "planned",
      "signIn",
      'proximityHit',
      'cabInOut' ,
      "distanceDriverDevice",
    ];
    ORIGINAL_COLS = JSON.parse(JSON.stringify(TABLE_COLUMNS.EMPLOYEE_DETAILS_COLUMNS))

    openModal() {
      this.commonService.getUnknownRfidData().subscribe((res:any)=>{
      const data = {
        ...this.commonService.tripDetails,
        'showUnknownRFID':true,
        'UnknownRfidData':res
      }

      this.showUnknownRFIDData(data)
    })

    }
    showUnknownRFIDData(data:any){

      TABLE_COLUMNS.EMPLOYEE_DETAILS_COLUMNS = TABLE_COLUMNS.UNKNOWN_RFID_COLUMNS
      const ref =  this.modalSvc.show(EmployeeDetailsComponent,  { closeOnBackdropClick: false, data: data });
      ref.overlay.backdropClick().subscribe((res)=>{
        ref.close();
        TABLE_COLUMNS.EMPLOYEE_DETAILS_COLUMNS = this.ORIGINAL_COLS;
      })
      
    }

    tripDetails;
    shiftTime;
    shiftDate;
    OfflineAudioCompletionEvent;
    officeStops=[];
    plannedSignIn=0;
    adhocs=0;
    noShows=0;
    notBoarded=0;
    employeeStatus=new Map<string,string>();
    dataServiceObserver$ : Subscription;
    isTableExpanded = false;
    ETS_MASTER_PROPERTIES : any = {}
  //  dataStudentsList = new MatTableDataSource();
   // displayedStudentsColumnsList: string[] = ['id', 'name', 'age', 'address', 'actions'];

  ngOnInit(): void 
  {
    this.imgSrc = this.envService.getImgSrc();
    this.commonService.employeeDetails$.subscribe((data)=>
    {
      this.employee_details_list=data
      this.temp_employee_details_list=this.employee_details_list
      console.log('employee details fire',this.employee_details_list);
      setTimeout(()=>{
        this.toggleColumns('collapse')
        this.filterFunction()
      },3)
      
      
    })
    this.tripDetails=this.commonService.response['tripDetails'];
    console.log("data in table",this.tripDetails);
    this.shiftDate= this.tripDetails.shift.date;
    this.shiftTime = DateUtils.formatTimeWithZone(this.shiftDate, this.commonService.timeZone, 'HH:mm');
    this.tripDetails.shuttleStops.forEach((stop)=>{
       if(stop.stopContext==='OFFICE'){
        this.officeStops.push(stop);
       }
    });
    if(this.officeStops.length>1){
      this.employee_detail_column.splice(7, 0, 'office');
    }
    if(this.isFdDistanceEnabled()){
      this.employee_detail_column.push('distanceFixedDevice');
    }
    this.calculateEmployeesStatus();
   

    const lineElement = document.getElementById('Line');
   if (lineElement) {
    lineElement.style.height = (56+this.temp_employee_details_list.length*48)+'px';
   }
    this.dataServiceObserver$ = this.dataService.ETS_PROPERTIES$.subscribe((properties:Record<string,any>)=>{
          this.ETS_MASTER_PROPERTIES = properties;
    })
  }


    getEmployeeHiddenText(employee: any, type: string): string {
        const gender = employee.gender || '';
        const phone = employee.phone || '';
        const pickUpLocation = employee?.location;
        const tripDirection = this.tripDetails?.direction;
        const isVendor = this.dataService.isVendorRole();
        const hidePhoneForVendors = this.ETS_MASTER_PROPERTIES?.HIDE_EMP_PHONE_NO_FROM_VENDORS;
        const hideAddressForVendors = this.ETS_MASTER_PROPERTIES?.HIDE_EMP_ADDRESS_FROM_VENDORS;
        const hiddenInfoText = this.ETS_MASTER_PROPERTIES?.TEXT_SHOWN_FOR_HIDDEN_INFO_TO_VENDORS;

        const hidePhoneNumberForVendorsOrNot = () => {
            if (!isVendor) return false;
            switch (hidePhoneForVendors) {
                case 'All employees':
                    return true;
                case 'Female employees only':
                    return gender === 'Female';
                case 'Disabled':
                    return false;
                default:
                    return false;
            }
        };
    
        switch (type) {
            case 'phone':
                return hidePhoneNumberForVendorsOrNot() ? hiddenInfoText : phone;
            case 'pickup':
                return this.tripDetails.direction === 'IN' ?   (isVendor && hideAddressForVendors) ? hiddenInfoText : pickUpLocation ??  '' : pickUpLocation ??  '';
            default:
                  return '';
       }
      }
  calculateEmployeesStatus(){
   this.employee_details_list.forEach((emp)=>{
    if(emp.actualPickupLocation!=null && emp.adhoc===false && emp.noShow===false){
      this.plannedSignIn++;
      this.employeeStatus.set(emp.Id,'planned')
    }else
    if(emp.adhoc===true){
      this.adhocs++;
      this.employeeStatus.set(emp.Id,'adhoc')
    }else
    if(emp.noShow===true && emp.plannedPickupLocation!=null){
      this.noShows++;
      this.employeeStatus.set(emp.Id,'noshow')
    }else
    if(emp.actualPickupLocation===null && emp.adhoc===false){
      this.notBoarded++;
      this.employeeStatus.set(emp.Id,'notboarded')
    }
   })
   console.log('employeestatus',this.employeeStatus);
   
  }
  ngAfterViewInit(): void {
    this.toggleColumns('collpase');
  }
  ngOnChanges(changes: SimpleChanges): void {
    
  //  this.toggleColumns('collpase');
  }
  // this.unassigned_vendor_list=this.unassigned_vendor_list.filter((obj: any) => obj.shiftType=='IN')

  ngOnDestroy(): void {
    this.dataServiceObserver$.unsubscribe();
  }

  toggleSelectedButtons(value:any)
  {
    if(value=='planned')
    {
      this.selectedPlannned=!this.selectedPlannned
      this.filterFunction()
    }
    if(value=='noShow')
    {
      this.selectedNoShow=!this.selectedNoShow
      this.filterFunction()
    }
    if(value=='adhoc')
    {
      this.selectedAdHoc=!this.selectedAdHoc
      this.filterFunction()
    }
    if(value=='notBoarded')
    {
      this.selectedNotBoarded=!this.selectedNotBoarded
      this.filterFunction()
    }
  }

  filterFunction()
  {
    // if(this.selectedPlannned && this.selectedNoShow && this.selectedAdHoc && this.selectedNotBoarded)
    // {
    //   this.temp_employee_details_list=this.employee_details_list 
    // } 

    // else if(this.selectedPlannned && this.selectedNoShow && !this.selectedAdHoc)
    // {
    //   this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.adhoc == false || obj.noShow == true) 
    // }

    // else if(this.selectedPlannned && !this.selectedNoShow && this.selectedAdHoc)
    // {
    //   this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == false || obj.adhoc == true ) 
    // }

    // else if(this.selectedPlannned && !this.selectedNoShow && !this.selectedAdHoc)
    // {
    //   this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.adhoc == false && obj.noShow == false) 
    // }

    // else if(!this.selectedPlannned && this.selectedNoShow && this.selectedAdHoc)
    // {
    //   this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.adhoc == true || obj.noShow == true) 
    // }

    // else if(!this.selectedPlannned && this.selectedNoShow && !this.selectedAdHoc)
    // {
    //   this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.adhoc == false && obj.noShow == true) 
    // }

    // else if(!this.selectedPlannned && !this.selectedNoShow && this.selectedAdHoc)
    // {
    //   this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.adhoc == true && obj.noShow == false) 
    // }

    // else if(!this.selectedPlannned && !this.selectedNoShow && !this.selectedAdHoc)
    // {
    //   this.temp_employee_details_list=this.employee_details_list 
    // }





    if (this.selectedPlannned && this.selectedNoShow && this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list ;
    } else if (this.selectedPlannned && this.selectedNoShow && this.selectedAdHoc && !this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.actualPickupLocation!=null) ;
    } else if (this.selectedPlannned && this.selectedNoShow && !this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.adhoc == false || obj.noShow == true || obj.actualPickupLocation===null) ;
    } else if (this.selectedPlannned && this.selectedNoShow && !this.selectedAdHoc && !this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> (obj.adhoc == false || obj.noShow == true) && obj.actualPickupLocation!=null) ;

    } else if (this.selectedPlannned && !this.selectedNoShow && this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == false || obj.adhoc== true || obj.actualPickupLocation==null) ;
    } else if (this.selectedPlannned && !this.selectedNoShow && this.selectedAdHoc && !this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == false || obj.adhoc== true || obj.actualPickupLocation!=null) ;

    } else if (this.selectedPlannned && !this.selectedNoShow && !this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == false || obj.adhoc== false || obj.actualPickupLocation==null) 

    } else if (this.selectedPlannned && !this.selectedNoShow && !this.selectedAdHoc && !this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == false && obj.adhoc== false && obj.actualPickupLocation!=null) 

    } else if (!this.selectedPlannned && this.selectedNoShow && this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == true || obj.adhoc== true || obj.actualPickupLocation==null) 

    } else if (!this.selectedPlannned && this.selectedNoShow && this.selectedAdHoc && !this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == true || obj.adhoc== true || obj.actualPickupLocation!=null) 

    } else if (!this.selectedPlannned && this.selectedNoShow && !this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == true || obj.adhoc== false || obj.actualPickupLocation==null) 

    } else if (!this.selectedPlannned && this.selectedNoShow && !this.selectedAdHoc && !this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == true && obj.actualPickupLocation==null) 

    } else if (!this.selectedPlannned && !this.selectedNoShow && this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == false || obj.adhoc== true || obj.actualPickupLocation==null) 

    } else if (!this.selectedPlannned && !this.selectedNoShow && this.selectedAdHoc && !this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=> obj.noShow == false && obj.adhoc== true && obj.actualPickupLocation!=null) 

    } else if (!this.selectedPlannned && !this.selectedNoShow && !this.selectedAdHoc && this.selectedNotBoarded) {
      this.temp_employee_details_list=this.employee_details_list.filter((obj:any)=>  obj.actualPickupLocation==null) 

    } else {
      this.temp_employee_details_list=this.employee_details_list;
    }







    const lineElement = document.getElementById('Line');
    if (lineElement) {
     lineElement.style.height = (57+this.temp_employee_details_list.length*48)+'px';
    }
    setTimeout(()=>{
      this.toggleColumns('collapse')
    },3)
   
      
  }

  toggleTableRows() {
    this.isTableExpanded = !this.isTableExpanded;

    this.temp_employee_details_list.data.forEach((row: any) => {
      row.isExpanded = this.isTableExpanded;
    })
  }

  

  closeModal() {
    this.modalRef.close();
  }

  toggleColumns(value){
    console.log('employee details fire1');
    
   if(value==='expand'){
     this.isTableExpanded=true;
     let table = document.getElementById("myTable");
     if (!table || !table?.['rows']?.length) return;
     let headerCells = table?.['rows']?.[0]?.cells;
     if (headerCells?.length >= 4) {
      headerCells[2].style.display = 'table-cell';
      headerCells[3].style.display = 'table-cell';
    }
  
     for (var j = 1; j < table?.['rows']?.length; j++) {
      const rowCells = table?.['rows']?.[j]?.cells;
      if (rowCells?.length >= 4) {
      rowCells[2].style.display = 'table-cell';
      rowCells[3].style.display = 'table-cell';
      }
    }
   }else {
    this.isTableExpanded=false;
    let table = document.getElementById("myTable");
    if (!table || !table?.['rows']?.length) return;

    
    let headerCells = table?.['rows']?.[0]?.cells;
    if (headerCells?.length >= 4) {
    headerCells[2].style.display = 'none';
    headerCells[3].style.display = 'none';
    }
    for (var j = 1; j < table?.['rows']?.length; j++) {
      const rowCells = table?.['rows']?.[j]?.cells;
      if (rowCells?.length >= 4) {
     rowCells[2].style.display = 'none';
     rowCells[3].style.display = 'none';
      }
   }
   }
   
  }
  getEmployeeStatus(id){
    let status = document.getElementById("status-"+id);
    
   if(this.employeeStatus.get(id)==='planned'){
    
    status.classList.add("boarded-status");
    return 'BOARDED';
   }else if(this.employeeStatus.get(id)==='noshow'){
    
    status.classList.add("noshow-status");
    return 'NO-SHOW';
   }else if(this.employeeStatus.get(id)==='adhoc'){
   
    status.classList.add("adhoc-status");
    return 'AD-HOC';
   }else {
    
    status.classList.add("notboarded-status");
    return 'NOT-BOARDED';
   }
  }
  
  formatNoShowTimestamp(timestamp: number): string {
    if (!timestamp) return '--';
    const timeZone = this.commonService.timeZone || 'Asia/Kolkata';
    return DateUtils.formatTimeWithZone(timestamp, timeZone, 'HH:mm');
  }
}
